// Import helpers
import { getImage } from 'helpers/images';

// Import types
import { ImageType } from 'types/api/images';

// Import styles
import { ListItem, Image } from './styles';

export const Channel = ({ title, images }: any) => {
	const image = getImage(images, [ImageType.Logo]);

	return (
		<ListItem title={title}>
			<Image src={image} alt={title} />
		</ListItem>
	);
};
